import _toConsumableArray from "D:/Desktop/taurus_coding_libs/web_misuntech_com/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/imgs/China.svg';
import _imports_1 from '@/assets/imgs/uk.svg';
import _imports_2 from '@/assets/imgs/japan.svg';
import _imports_3 from '@/assets/logo.png';
var _hoisted_1 = {
  class: "nav-main-top"
};
var _hoisted_2 = {
  class: "nav-top-bg"
};
var _hoisted_3 = {
  class: "container nav-top"
};
var _hoisted_4 = {
  class: "left"
};
var _hoisted_5 = {
  class: "right"
};
var _hoisted_6 = {
  class: "container nav-header"
};
var _hoisted_7 = {
  class: "left"
};
import { setLocalStorage, getLocalStorage } from '@/methods/storage';
export default {
  __name: 'm-header',
  setup: function setup(__props) {
    var url = getLocalStorage('misun_linkurl');
    var activeIndex = url ? '/' + url : this.$route.path;
    var switchLang = function switchLang(type) {
      if (!type || ['zh', 'en', 'ja'].indexOf(type) < 0) return;
      setLocalStorage('misun_langs', type);
      location.reload();
    };
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      var _component_el_menu_item = _resolveComponent("el-menu-item");
      var _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.$t('telephone')) + ":", 1), _cache[3] || (_cache[3] = _createTextVNode("0523-86868006", -1))])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("a", {
        class: "item",
        href: "javascript:;",
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          return switchLang('zh');
        }, ["stop"]))
      }, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "icon",
        src: _imports_0
      }, null, -1)), _createTextVNode(_toDisplayString(_ctx.$t('lang_zh')), 1)]), _createElementVNode("a", {
        class: "item",
        href: "javascript:;",
        onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
          return switchLang('en');
        }, ["stop"]))
      }, [_cache[5] || (_cache[5] = _createElementVNode("img", {
        class: "icon",
        src: _imports_1
      }, null, -1)), _createTextVNode(_toDisplayString(_ctx.$t('lang_en')), 1)]), _createElementVNode("a", {
        class: "item",
        href: "javascript:;",
        onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
          return switchLang('ja');
        }, ["stop"]))
      }, [_cache[6] || (_cache[6] = _createElementVNode("img", {
        class: "icon",
        src: _imports_2
      }, null, -1)), _createTextVNode(_toDisplayString(_ctx.$t('lang_ja')), 1)])])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[7] || (_cache[7] = [_createElementVNode("img", {
            src: _imports_3,
            alt: "米山科技"
          }, null, -1)]));
        }),
        _: 1
      })]), _createVNode(_component_el_menu, {
        "default-active": _unref(activeIndex),
        class: "el-menu-misun",
        mode: "horizontal",
        "background-color": "transparent",
        "active-text-color": "#409EFF",
        router: "",
        ellipsis: false
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "/home"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t('nav_home')), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/about"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t('nav_about')), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/products"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t('nav_products')), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/technology"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t('nav_technology')), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/news"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t('nav_news')), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/contact"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t('nav_contact')), 1)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["default-active"])])]);
    };
  }
};